module.exports = __webpack_public_path__ + "img/2.83a75748.png";